export default {
  computed: {
    doctor1() {
      return require("@/assets/images/doctor-1.png");
    },
    doctor2() {
      return require("@/assets/images/doctor-2.png");
    },
    doctor3() {
      return require("@/assets/images/doctor-3.png");
    },
  },
};
